import React from 'react'
import { Radio } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { setCardStyle } from '../../Redux/slices/Preferences/preferences'
import { useComponentLocale } from '../../hooks/useComponentLocale'

export default function CardLayoutSettings() {
	const { cardLayout } = useSelector((state) => state.preferences.dataNew.common.cards)

	// todo: переделать на карты

	const dispatch = useDispatch()
	const getLocale = useComponentLocale()
	const cardStyleLocale = getLocale({ component: 'theme', section: 'card_style' })

	const renderRadioButtons = () => {
		const carsStyles = {
			V1: 0,
			V2: 1,
			V3: 2,
		}

		return Object.keys(carsStyles).map((styleNames) => (
			<Radio.Button value={carsStyles[styleNames]} key={styleNames}>
				{styleNames}
			</Radio.Button>
		))
	}

	return (
		<div style={{ display: 'flex', flexDirection: 'column', marginTop: 16, marginBottom: 16, marginLeft: 16 }}>
			<h4>{cardStyleLocale}</h4>

			<Radio.Group value={cardLayout} onChange={(e) => dispatch(setCardStyle(e.target.value))}>
				{renderRadioButtons()}
			</Radio.Group>
		</div>
	)
}
